__webpack_require__.p = "/React-CoinGecko-API-Crypto-Prices/";